module.exports = __webpack_public_path__ + "static/media/hand.7d5b4372.svg";